module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Folder-plus-b98aafc3b3cdf26c8ea8264109b6cb50.svg";